import { initialState } from './adapter';
import { AffiliateProgramsState } from './interfaces';

export const resetStateReducer = (state: AffiliateProgramsState): void => {
  state.ids = initialState.ids;
  state.entities = initialState.entities;
  state.offset = initialState.offset;
  state.limit = initialState.limit;
  state.total = initialState.total;
  state.status = initialState.status;
};
